import { IBusinessDetails } from '@forwardflow/types/onboarding'

export const INTRO_TEMPLATE_VARIANTS = [
   {
      value: 'Hi, this is {assistant-name} with {agent-name}',
      type: 'default',
   },
   {
      value: 'Hi, this is {assistant-name} with {team-name}',
      type: 'team',
   },
   {
      value: 'Hi, this is {assistant-name} with {brokerage-name}',
      type: 'default',
   },
   {
      value: 'Hi, this is {assistant-name} with {team-name} at {brokerage-name}',
      type: 'team',
   },
]

export const getFilteredVariants = (hasTeam: boolean) => {
   return INTRO_TEMPLATE_VARIANTS.filter((variant) =>
      variant.type === 'team' ? hasTeam : true
   )
}

export const getPlaceholderMap = (
   businessDetails?: IBusinessDetails | null
) => ({
   'assistant-name': 'Assistant Name',
   'agent-name': 'Agent Name',
   'team-name': businessDetails?.businessTeamName || 'Team Name',
   'brokerage-name': businessDetails?.businessBrokerageName || 'Brokerage Name',
})

export const renderTemplateWithPlaceholders = (
   template: string,
   placeholderMap: Record<string, string>
) => {
   return template.split(/({[^}]+})/).map((part, index) => {
      if (part.match(/^{.*}$/)) {
         const key = part.slice(1, -1)
         return (
            <span
               key={index}
               className="inline-block px-2 mx-0.5 rounded-[4px] bg-white/10 text-white/60 font-medium text-xs py-0.5"
            >
               {placeholderMap[key] || ''}
            </span>
         )
      }
      return part
   })
}
